import { getPricingCalculatorData } from '../../../../uniform/components/pricing-calculator/src/client/pricing-calculator-client.ts';
import { confluenceOfferingSkus } from '../../../../uniform/components/pricing-calculator/src/configs/confluence.pricing-calculator-config.ts';
import { jiraOfferingSkus } from '../../../../uniform/components/pricing-calculator/src/configs/jira.pricing-calculator-config.ts';
import { loomOfferingSkus } from '../../../../uniform/components/pricing-calculator/src/configs/loom.pricing-calculator-config.ts';
import { teamworkCollectionOfferingSkus } from '../../../../uniform/components/pricing-calculator/src/configs/teamwork-collection.pricing-calculator-config.ts';
import { Plan } from '../../../../uniform/components/pricing-calculator/src/types';

// These must match the Contentful entries' Pricing Title Internal field
export const pricingTitleInternal = {
	JIRA: 'Jira Pricing Page',
	CONFLUENCE: 'Confluence Pricing Page',
	TWC: 'Teamwork Collection Pricing Page',
	LOOM: 'Loom Pricing Page',
};

type ProductKey = ValueOf<typeof pricingTitleInternal>;
type ValueOf<T> = T[keyof T];

export type PlansByProduct = Record<ProductKey, Plan[]>;

export const getNonprofitPricingCalculatorData = async (): Promise<PlansByProduct> => {
	const result = await getPricingCalculatorData([
		pricingTitleInternal.JIRA,
		pricingTitleInternal.CONFLUENCE,
		pricingTitleInternal.TWC,
		pricingTitleInternal.LOOM,
	]);
	return omitEnterprisePlans(result as PlansByProduct);
};

const omitEnterprisePlans = (plansDataByProduct: PlansByProduct): PlansByProduct => {
	const jiraPlans =
		plansDataByProduct[pricingTitleInternal.JIRA]?.filter((plan) => {
			const sku = plan.pricingPlan?.sku;
			return sku !== jiraOfferingSkus.enterprise;
		}) ?? [];

	const confluencePlans =
		plansDataByProduct[pricingTitleInternal.CONFLUENCE]?.filter((plan) => {
			const sku = plan.pricingPlan?.sku;
			return sku !== confluenceOfferingSkus.enterprise;
		}) ?? [];

	const teamworkCollectionPlans =
		plansDataByProduct[pricingTitleInternal.TWC]?.filter((plan) => {
			const sku = plan.pricingPlan?.sku;
			return sku !== teamworkCollectionOfferingSkus.enterprise;
		}) ?? [];

	const loomPlans =
		plansDataByProduct[pricingTitleInternal.LOOM]?.filter((plan) => {
			const sku = plan.pricingPlan?.sku;
			return sku !== loomOfferingSkus.enterprise;
		}) ?? [];

	return {
		[pricingTitleInternal.JIRA]: jiraPlans,
		[pricingTitleInternal.CONFLUENCE]: confluencePlans,
		[pricingTitleInternal.TWC]: teamworkCollectionPlans,
		[pricingTitleInternal.LOOM]: loomPlans,
	} as PlansByProduct;
};
